module.exports = __webpack_public_path__ + "static/media/parceiro-premed.08b487b9.webp";